module.exports = Fancybox;